// BonBoZ: CHỦ ĐỀ MÀU cho khung app — thanh trên + thanh bên trái — như Pancake.
//
// Pancake cho mỗi nhân viên tự chọn màu khung trong Cài đặt cá nhân (8 ô, ô
// đang dùng có dấu tích). Người chuyển từ Pancake sang hỏi ngay "đổi màu ở
// đâu", nên đây là thứ phải có chứ không phải trang trí.
//
// Toàn bộ bảng màu nằm ở ĐÂY, một chỗ duy nhất. `applyTheme` ghi ba biến CSS
// thẳng lên <html> (inline thắng mọi stylesheet) — SCSS chỉ giữ giá trị mặc định
// và một luật nhỏ cho theme sáng. Không chép bảng màu sang SCSS: hai bản dễ lệch
// nhau mà không ai nhận ra cho tới khi ô xem trước một màu, khung một màu khác.
//
// Ba biến:
//   --bonboz-nen-khung   nền khung, nhận cả gradient (dùng làm `background`)
//   --bonboz-chu-khung   bộ ba RGB của chữ/viền trên khung, dùng qua rgb(... / a%)
//   --pk-chrome          bộ ba RGB "màu đại diện" — cho các chỗ cần MỘT màu đặc
//                        (vòng quanh huy hiệu số đỏ), gradient không dùng được
//
// Lưu theo tài khoản trong `uiSettings.bonboz_chu_de` — đổi trên máy này thì
// máy kia cũng theo, giống Pancake.
//
// `logo`: logo = đĩa teal (viền kem, hình khoét kem) + CHỮ. Trên nền xanh lá /
// xanh biển đĩa teal chìm vào nền, trên nền sáng chữ teal mất; nên mỗi chủ đề
// chỉ một file trong public/brand-assets, khác nhau ở màu đĩa và màu chữ:
//   logo.svg          đĩa teal, chữ teal — nền xanh/tím/đêm (đang dùng)
//   logo_dia-kem.svg  đĩa kem, hình teal, chữ kem — nền xanh lá / xanh biển
//   logo_light.svg    đĩa teal, chữ tối — nền sáng
// Không dùng filter CSS để "tối logo lại": filter đè lên cả đĩa lẫn hình, ra
// một khối xám đục.

import { ref } from 'vue';

export const CHU_DE_MAC_DINH = 'xanh';

// Tên chủ đề ĐANG hiện trên màn hình. Khác với `uiSettings.bonboz_chu_de` ở
// chỗ nó đổi ngay khi bấm, còn uiSettings chỉ đổi sau khi lưu xong — ai cần
// đổi theo chủ đề (logo trên thanh trên) thì đọc cái này, không thì trễ nửa
// giây so với màu nền.
export const chuDeHienTai = ref(CHU_DE_MAC_DINH);

// Người dùng đã tự bấm chọn trên máy này chưa. Sau khi đã bấm, phản hồi của
// máy chủ (store ghi đè uiSettings mỗi lần lưu xong) KHÔNG được áp lại lên
// màn hình: phản hồi về chậm 0,5–1 s và có thể ngược thứ tự, áp lại thì màu bị
// kéo lùi về ô đã bỏ. Giá trị máy chủ chỉ dùng lúc nạp app.
let daTuChon = false;
export const hasLocalThemeChoice = () => daTuChon;

const TRANG = '255 255 255';
const CHU_TOI = '29 41 57'; // = --pk-chu-chinh, cho theme sáng

export const CAC_CHU_DE = [
  {
    ten: 'sang',
    logo: '/brand-assets/logo_light.svg',
    emoji: '🚀',
    nen: 'rgb(241 245 249)',
    chu: CHU_TOI,
    daiDien: '241 245 249',
  },
  {
    // Màu hiện tại của BonBoZ. Là mặc định để ai chưa chọn gì thì không thấy
    // khác biệt nào sau lần deploy này.
    ten: 'xanh',
    logo: '/brand-assets/logo.svg',
    emoji: '🏙️',
    nen: 'rgb(80 109 173)',
    chu: TRANG,
    daiDien: '80 109 173',
  },
  {
    ten: 'hoang-hon',
    logo: '/brand-assets/logo.svg',
    emoji: '🪐',
    nen: 'linear-gradient(165deg, rgb(74 122 182) 0%, rgb(182 104 134) 100%)',
    chu: TRANG,
    daiDien: '128 113 158',
  },
  {
    ten: 'dem',
    logo: '/brand-assets/logo.svg',
    emoji: '🌙',
    nen: 'rgb(30 42 56)',
    chu: TRANG,
    daiDien: '30 42 56',
  },
  {
    ten: 'ky-lan',
    logo: '/brand-assets/logo.svg',
    emoji: '🦄',
    nen: 'linear-gradient(165deg, rgb(104 110 200) 0%, rgb(160 126 216) 100%)',
    chu: TRANG,
    daiDien: '132 118 208',
  },
  {
    ten: 'song',
    logo: '/brand-assets/logo_dia-kem.svg',
    emoji: '🌊',
    nen: 'linear-gradient(165deg, rgb(56 122 180) 0%, rgb(72 160 194) 100%)',
    chu: TRANG,
    daiDien: '64 141 187',
  },
  {
    ten: 'trai-dat',
    logo: '/brand-assets/logo_dia-kem.svg',
    emoji: '🌍',
    nen: 'linear-gradient(165deg, rgb(70 124 190) 0%, rgb(166 196 104) 100%)',
    chu: TRANG,
    daiDien: '118 160 147',
  },
  {
    ten: 'co-bon-la',
    logo: '/brand-assets/logo_dia-kem.svg',
    emoji: '🍀',
    nen: 'linear-gradient(165deg, rgb(20 158 112) 0%, rgb(12 134 122) 100%)',
    chu: TRANG,
    daiDien: '16 146 117',
  },
];

// Màu cho `<meta name="theme-color">`: thanh trạng thái điện thoại khi mở app
// đã cài, thanh địa chỉ Chrome Android. Lấy màu ĐẦU của nền chứ không lấy
// `daiDien`: thanh trạng thái nằm sát mép trên khung, gradient 165° bắt đầu từ
// trên, dùng màu trung bình thì chỗ nối lệch màu.
export const mauThanhTrangThai = chuDe => {
  const [r, g, b] = chuDe.nen.match(/rgb\((\d+) (\d+) (\d+)\)/).slice(1);
  return `#${[r, g, b]
    .map(v => Number(v).toString(16).padStart(2, '0'))
    .join('')
    .toUpperCase()}`;
};

const ganMauThanhTrangThai = chuDe => {
  let the = document.querySelector('meta[name="theme-color"]');
  if (!the) {
    the = document.createElement('meta');
    the.name = 'theme-color';
    document.head.appendChild(the);
  }
  the.content = mauThanhTrangThai(chuDe);
};

export const timChuDe = ten =>
  CAC_CHU_DE.find(c => c.ten === ten) ||
  CAC_CHU_DE.find(c => c.ten === CHU_DE_MAC_DINH);

/**
 * Ghi chủ đề lên <html>. Gọi lúc app nạp (từ uiSettings) và ngay khi bấm chọn.
 * Tên không hợp lệ (dữ liệu cũ, gõ tay) rơi về mặc định chứ không để khung
 * mất màu.
 */
export const applyTheme = ten => {
  if (typeof document === 'undefined') return;
  const chuDe = timChuDe(ten);
  const goc = document.documentElement;

  chuDeHienTai.value = chuDe.ten;
  goc.dataset.bonbozChuDe = chuDe.ten;
  goc.style.setProperty('--bonboz-nen-khung', chuDe.nen);
  goc.style.setProperty('--bonboz-chu-khung', chuDe.chu);
  goc.style.setProperty('--pk-chrome', chuDe.daiDien);
  ganMauThanhTrangThai(chuDe);
};

/** Người dùng bấm chọn: áp ngay và từ đây bỏ qua tiếng vọng từ máy chủ. */
export const chonChuDe = ten => {
  daTuChon = true;
  applyTheme(ten);
};
